import React from "react";
import { makeStyles } from "@styles";

const useStyles = makeStyles(() => ({
  gridCardRowContainer: {
    display: "grid",
    gridColumnGap: 18,
    marginTop: 16,
    maxWidth: 1400,
    overflow: "visible",
  },
}));

type Props = {
  children: JSX.Element[];
  maxItemsPerRow: number;
  style: any;
};

export function GridCardRowContainer({ children, maxItemsPerRow, style }: Props) {
  const classes: any = useStyles({});

  return (
    <div
      style={{
        ...style,
        gridTemplateColumns: `repeat(${maxItemsPerRow}, minmax(0, 1fr))`,
      }}
      className={classes.gridCardRowContainer}
    >
      {children}
    </div>
  );
}
